import Vue from "vue";
import Router from "vue-router";
import store from '../store';
import Layout from "../views/Layout.vue";
import Login from "../views/Login.vue";
import {
  getToken
} from '@/utils/storage'

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
var router = new Router({
  routes: [{
      path: "/",
      name: "index",
      component: Layout,
      redirect: '/home',
      children: [{
          path: '/home',
          name: '首页',
          component: () =>
            import ('@/views/home/index'),
          redirect: '/home/data',
          children: [{
              path: 'data',
              name: '数据',
              component: () =>
                import ('@/views/home/data/index')
            },
            {
              path: 'todo',
              name: '待办',
              component: () =>
                import ('@/views/home/todo/index')
            },
            {
              path: 'notice',
              name: '通知',
              component: () =>
                import ('@/views/home/notice/index')
            }
          ]
        },
        {
          path: '/custom',
          name: '客户',
          component: () =>
            import ('@/views/custom/index'),
            meta:{
              keepAlive:true,
              isBack:false,
              title:"客户"
            },
        },
        {
          path: '/reports',
          name: '报表',
          component: () =>
            import ('@/views/reports/index')
        },
        {
          path: '/person',
          name: '个人中心',
          component: () =>
            import ('@/views/person/index')
        }
      ]
    },
    {
      path: '/home/data/registration/searchCustomer',
      name: '查询客户',
      component: () =>
        import ('@/views/home/data/registration/searchCustomer')
    },
    {
      path: '/home/data/registration/registCustomer',
      name: '客户登记',
      component: () =>
        import ('@/views/home/data/registration/registCustomer')
    },
    {
      path: '/home/data/customerReport',
      name: '报备客户',
      component: () =>
        import ('@/views/home/data/customerReport/index')
    },
    {
      path: '/home/data/customerReport/checkAddress',
      name: '选择地址',
      component: () =>
        import ('@/views/home/data/customerReport/checkAddress')
    },
    {
      path: '/home/data/publicPool',
      name: '公共池',
      component: () =>
        import ('@/views/home/data/publicPool/index')
    },
    {
      path: '/home/data/publicPool/publicPoolHistory',
      name: '公共池分配历史',
      component: () =>
        import ('@/views/home/data/publicPool/publicPoolHistory/index')
    },
    {
      path: '/home/data/reviewHistory',
      name: '审核历史',
      component: () =>
        import ('@/views/home/data/reviewHistory/index')
    },
    {
      path: '/home/data/reviewHistory/details',
      name: '审核历史详情',
      component: () =>
        import ('@/views/home/data/reviewHistory/details')
    },
    {
      path: '/home/todo/visitReviewCusList',
      name: '确认到访待审核客户',
      component: () =>
        import ('@/views/home/todo/visitReviewCusList/index'),
       meta:{keepAlive:true}
    },
    {
      path: '/home/todo/shellTree',
      name: '贝壳树新客户',
      component: () =>
        import ('@/views/home/todo/shellTree/index'),
        meta:{keepAlive:true}
    },
    {
      path: '/home/todo/visitReviewReject',
      name: '驳回原因',
      component: () =>
        import ('@/views/home/todo/visitReviewReject/index')
    },
    {
      path: '/home/todo/personReview',
      name: '人员待审核',
      component: () =>
        import ('@/views/home/todo/personReview/index')
    },
   
    {
      path: '/home/todo/personReview/:id',
      name: '账号详情',
      component: () =>
        import ('@/views/home/todo/personReview/detail/index')
    },
    {
      path: '/home/data/branchHistory',
      name: '分接历史',
      component: () =>
        import ('@/views/home/data/branchHistory/index')
    },
    {
      path: '/home/data/printHistory',
      name: '打印历史',
      component: () =>
        import ('@/views/home/data/printHistory/index'),
        meta:{keepAlive:false }
    },
    {
      path: '/home/data/attendance',
      name: '考勤管理',
      component: () =>
        import ('@/views/home/data/attendance/index')
    },
    {
      path: "/home/data/map",
      name: "客户地图",
      component: () =>
        import ('@/views/home/data/map/index')
    },
    {
      path: "/home/data/workLocus",
      name: "工作轨迹",
      component: () =>
        import ('@/views/home/data/workLocus/index')
    },
    {
      path: "/home/data/signIn",
      name: "签到",
      component: () =>
        import ('@/views/home/data/signIn/index')
    },
    {
      path: "/home/data/signIn/signInHistory",
      name: "签到历史",
      component: () =>
        import ('@/views/home/data/signIn/signInHistory')
    },
    {
      path: "/home/data/group",
      name: "团队架构",
      component: () =>
        import ('@/views/home/data/group/index')
    },
    {
      path: "/home/data/group/edit",
      name: "新增组",
      component: () =>
        import ('@/views/home/data/group/opt/editGroup')
    },
    {
      path: "/home/data/group/plt",
      name: "新增分配",
      component: () =>
        import ('@/views/home/data/group/plt/index')
    },
    {
      path: "/home/data/group/mlt",
      name: "新增门店列表",
      component: () =>
        import ('@/views/home/data/group/mlt/index')
    },
    {
      path: "/home/data/groups",
      name: "团队架构",
      component: () =>
        import ('@/views/home/data/groups/index')
    },
    {
      path: "/home/data/groups/selePit",
      name: "组织名称修改1",
      component: () =>
        import ('@/views/home/data/groups/opt/editGroup')
    },
    {
      path: "/home/data/groups/sele",
      name: "修改信息1",
      component: () =>
        import ('@/views/home/data/groups/opt/edit')
    },
    {
      path: "/home/data/groups/plt",
      name: "新增分配1",
      component: () =>
        import ('@/views/home/data/groups/plt/index')
    },
    {
      path: "/home/data/groups/edit",
      name: "新增组1",
      component: () =>
        import ('@/views/home/data/groups/opt/editGroup')
    },
    {
      path: "/home/notice/list",
      name: "我的通知",
      component: () =>
        import ('@/views/home/notice/list')
    },
    {
      path: '/custom/details',
      name: '客户详情',
      component: () =>
        import ('@/views/custom/details/index'),
      children: [{
          path: '/custom/details/Trajectory',
          name: '客户轨迹',
          component: () =>
            import ('@/views/custom/details/tab/Trajectory')
        },
        {
          path: '/custom/details/Record',
          name: '跟进记录',
          component: () =>
            import ('@/views/custom/details/tab/Record')
        },
        {
          path: '/custom/details/Information',
          name: '交易信息',
          component: () =>
            import ('@/views/custom/details/tab/Information')
        },

      ]
    },
    {
      path: '/custom/details/personaformation',
      name: '完善个人信息',
      component: () =>
        import ('@/views/custom/details/personaformation/index')
    },
    {
      path: '/custom/details/redistribution',
      name: '重分配',
      component: () =>
        import ('@/views/custom/details/redistribution/index'),
    },
    /* 选择置业顾问 */
    {
      path: '/custom/details/distribution',
      name: '分配',
      component: () =>
        import ('@/views/custom/details/distribution/index')
    },
    {
      path: "/custom/details/party",
      name: "关系人",
      component: () =>
        import ('@/views/custom/details/party/index')
    },
    {
      path: "/custom/details/follow",
      name: "客户跟进",
      component: () =>
        import ('@/views/custom/details/follow/index')
    },
    {
      path: "/custom/details/trancsaction",
      name: "提交交易",
      component: () =>
        import ('@/views/custom/details/trancsaction/index')
    },
    {
      path: "/custom/details/tokeraboutlist",
      name: "拓客归属人列表",
      component: () =>
        import ('@/views/custom/details/tokeraboutlist/index')
    },
    {
      path: "/person/setup",
      name: "设置",
      component: () =>
        import ('@/views/person/setup')
    },
    {
      path: '/person/changeName',
      name: '修改姓名',
      component: () =>
        import ('@/views/person/changeName')
    },
    {
      path: '/person/changePwd',
      name: '修改密码',
      component: () =>
        import ('@/views/person/changePwd')
    },

    {
      path: '/person/getPwd',
      name: '找回密码',
      component: () =>
        import ('@/views/person/getPwd')
    },
    {
      path: "/person/shelltree",
      name: "贝壳树",
      component: () =>
        import ('@/views/person/shelltree')
    },

    {
      path: "/person/Invitationregistration",
      name: "邀请注册",
      component: () =>
        import ('@/views/person/Invitationregistration')
    }, 
		{
      path: "/person/protocol",
      name: "实地售楼",
      component: () =>
        import ('@/views/person/protocol')
    },
    {
      path: "/person/team",
      name: "邀请进团",
      component: () =>
        import ('@/views/person/team')
    },
    {
      path: "/person/code",
      name: "打赏二维码",
      component: () =>
        import ('@/views/person/code')
    },
    {
      path: "/person/reward",
      name: "打赏详情",
      component: () =>
        import ('@/views/person/reward')
    },
    {
      path: "/reports/customEchart",
      name: "客户统计",
      component: () =>
        import ('@/views/reports/custom/index')
    },
    {
      path: "/reports/static",
      name: "分配统计",
      component: () =>
        import ('@/views/reports/static/index')
    },
    {
      path: "/reports/customEchartt",
      name: "逾期统计",
      component: () =>
        import ('@/views/reports/custom/index')
    },
    {
      path: "/reports/staticc",
      name: "客户分析",
      component: () =>
        import ('@/views/reports/staticc/index')
    },
    {
      path: "/person/comment",
      name: "评分详情",
      component: () =>
        import ('@/views/person/comment')
    },
    
  
    {
      path: '/person/openingClient',
      name: '开盘客户',
      component: () => 
        import('@/views/person/openingClient')
    },
    {
      path: "/Login",
      name: "Login",
      component: Login
    }
  ]
});
// 不重定向白名单
const whiteList = ['/Login'];
// 路由守卫设置
router.beforeEach(function (to, from, next) {
  if (getToken()) {
    if (to.path === '/Login') {
      next()
    } else {
      if (!store.getters.user) {
        // 拉取用户信息
        store.dispatch('GetInfo').then(res => {
          next();
        }).catch((err) => {
          // 清空
          store.dispatch('FedLogOut').then(() => {
            next({
              path: '/'
            });
          });
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {   
      next();
    } else {
      if(to.path=== '/person/Invitationregistration'){
        next()
      }else if(to.path=== '/person/getPwd'){
        next()
      }else if(to.path=== '/person/protocol'){
        next()
      }else{
        next('/Login'); // 否则全部重定向到登录页
      }
     //   next('/person/Invitationregistration'); // 否则全部重定向到登录页


    }
  }
});

export default router;